import styled from "styled-components";
import { breakpoints, maxBreakpoints } from "../../../../../../../shared-logic/themes/lexusTheme";

export const Wrapper = styled.div`
    background: var(--color-white);
    border: 1px solid var(--color-platinum-light);
    border-radius: 4px;
`;

export const List = styled.dl`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-1);
    padding: var(--spacing-2);

    &:not(:last-child) {
        border-bottom: 1px solid var(--color-platinum-light);
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        padding: var(--spacing-3);
    }
`;

export const SpecItem = styled.div`
    display: flex;
    align-items: flex-start;
    align-self: stretch;
    justify-content: space-between;
    column-gap: var(--spacing-1);

    dt,
    dd {
        font-size: 1.3rem;
        font-weight: 400;
        line-height: 2rem;
    }

    dt {
        @media screen and (max-width: ${maxBreakpoints.sm}) {
            max-width: 60%;
        }
    }

    dd {
        display: flex;
        flex-shrink: 0;
        align-items: center;
        column-gap: calc(var(--spacing-1) / 2);
    }
`;

export const Sup = styled.span`
    font-size: 1rem;
    line-height: 2rem;
    vertical-align: super;
`;

export const Footnote = styled.div`
    display: flex;
    column-gap: calc(var(--spacing-1) / 2);
    font-family: var(--font-book);
    font-size: 1.3rem;
    line-height: 2rem;
`;

export const FootnoteNumber = styled.div`
    width: 24px;
`;

export const IntegratedEmissionlabelWrapper = styled.div`
    margin-block-end: var(--spacing-1);

    @supports not (margin-block: 0) {
        margin-bottom: var(--spacing-1);
    }

    /* Override styles ecolabel */
    [class*="EmissionLabel__emission--"] {
        --or-_label-height: 2rem;
        --or-tdg-label-height: 2rem;
        --or-tdg-label-line-height: 1.8rem;
        --or-tdg-label-margin: 0.4rem;
        --or-tdg-label-a-width: 4rem;
        --or-tdg-label-b-width: 5rem;
        --or-tdg-label-c-width: 6rem;
        --or-tdg-label-d-width: 7rem;
        --or-tdg-label-e-width: 8rem;
        --or-tdg-label-f-width: 9rem;
        --or-tdg-label-g-width: 10rem;
        --or-tdg-emission-indicator-width: 2.5rem;
        --or-tdg-emission-font-size: 1.4rem;
        --or-_point-width: calc(var(--or-tdg-label-height) / 2);

        [data-part="emission-value-col"] {
            font-size: var(--or-eco-consumption-default-font-size, 1.2rem);
        }
    }

    [class*="EmissionLabel__emission-label--"] {
        /* Fix alignment between eco-label-bars */
        margin-top: var(--or-tdg-label-margin);
        margin-bottom: var(--or-tdg-label-margin);
        /* Fix width border around text in eco-label */
        text-shadow:
            0.5px 0.5px 0 #000,
            0.5px -0.5px 0 #000,
            -0.5px 0.5px 0 #000,
            -0.5px -0.5px 0 #000,
            0.5px 0 0 #000,
            0 0.5px 0 #000,
            -0.5px 0 0 #000,
            0 -0.5px 0 #000,
            0 0 0 transparent;
    }
`;
